export const buyTypeLabels: { [key in BuyType]: string } = {
    Display: 'Display',
    Search: 'Search',
    Social: 'Social',
};
